import {ChangeDetectionStrategy, Component, inject, input} from "@angular/core";
import {Attachment} from "../../../../attachments/models/attachment.model";
import {AttachmentsDialog} from "../../../../attachments/services/attachments-dialog.service";

@Component({
  selector: "app-images-link-popup",
  templateUrl: "./images-link-popup.html",
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ImagesLinkPopupComponent {
  readonly attachments = input<Attachment[]>([]);

  private readonly attachmentsDialog = inject<AttachmentsDialog>("attachmentsDialog" as never);

  onOpen(event: MouseEvent): void {
    this.attachmentsDialog.imagesDialog(event, this.attachments());
  }
}
